import React, { useState } from "react";
import axios from "../utils/axiosInstance";

export default function BarizaUmuturage() {
  const [question, setQuestion] = useState("");
  const [sending, setSending]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [error, setError]       = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!question.trim()) { setError("Andika ikibazo mbere yo kohereza."); return; }
    setSending(true); setError(null);
    try {
      await axios.post("/api/questions", { question_text: question.trim() });
      setSuccess(true);
      setQuestion("");
    } catch (err) {
      setError(err?.response?.data?.error || "Kohereza byanze. Gerageza nanone.");
    } finally { setSending(false); }
  };

  return (
    <div style={{ fontFamily:"Nunito Sans, sans-serif", maxWidth:640, margin:"0 auto" }}>
      {/* Header */}
      <div style={{ marginBottom:20 }}>
        <h2 style={{ margin:0, fontSize:"1.05rem", fontWeight:700, color:"#0d1b2a", display:"flex", alignItems:"center", gap:8 }}>
          <i className="bi bi-chat-square-quote-fill" style={{ color:"#0047AB" }} /> Bariza Umuturage
        </h2>
        <p style={{ margin:"4px 0 0", fontSize:"0.78rem", color:"#64748b" }}>Ohereza ikibazo ku Kagari</p>
      </div>

      {success ? (
        <div style={{ background:"#ffffff", border:"1px solid #e2e8f0", borderRadius:8, padding:"2.5rem", textAlign:"center", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
          <div style={{ width:64, height:64, borderRadius:"50%", background:"rgba(32,96,61,0.12)", color:"#20603d", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1.8rem", margin:"0 auto 16px" }}>
            <i className="bi bi-check-circle-fill" />
          </div>
          <h4 style={{ color:"#20603d", fontWeight:700, marginBottom:8 }}>Byoherejwe Neza!</h4>
          <p style={{ color:"#64748b", marginBottom:20, fontSize:"0.9rem" }}>Ikibazo cyoherejwe neza kuri Kagari.</p>
          <button onClick={() => setSuccess(false)}
            style={{ padding:"10px 24px", borderRadius:6, border:"none", background:"#0047AB", color:"#fff", fontWeight:700, cursor:"pointer", fontSize:"0.88rem" }}>
            <i className="bi bi-plus-lg" style={{ marginRight:6 }} /> Ohereza Ikindi Kibazo
          </button>
        </div>
      ) : (
        <div style={{ background:"#ffffff", border:"1px solid #e2e8f0", borderRadius:8, padding:"24px", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20, padding:"12px 16px", background:"rgba(250,210,1,0.12)", border:"1px solid rgba(250,210,1,0.35)", borderRadius:6 }}>
            <i className="bi bi-info-circle-fill" style={{ color:"#b8860b" }} />
            <span style={{ fontSize:"0.82rem", color:"#334155" }}>Ikibazo cyawe cyohererezwa ako kanya kuri Kagari gashinzwe umudugudu wawe.</span>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:20 }}>
              <label style={{ display:"block", fontSize:"0.75rem", fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>
                Ikibazo cyawe *
              </label>
              <textarea
                value={question}
                onChange={e => { setQuestion(e.target.value); setError(null); }}
                placeholder="Andika ikibazo cyawe hano... Ikibazo cyawe kizohererezwa ku Kagari."
                rows={6}
                style={{ width:"100%", padding:"14px 16px", borderRadius:8, border:`1px solid ${error ? "#f43f5e" : "#e2e8f0"}`, background:"#f8fafc", color:"#0d1b2a", fontSize:"0.9rem", outline:"none", resize:"vertical", boxSizing:"border-box", lineHeight:1.7 }}
              />
              <div style={{ display:"flex", justifyContent:"space-between", marginTop:4 }}>
                <span style={{ fontSize:"0.72rem", color: question.length > 1000 ? "#f43f5e" : "#94a3b8" }}>{question.length}/1000</span>
                {question.length > 0 && <button type="button" onClick={() => setQuestion("")} style={{ background:"none", border:"none", color:"#94a3b8", fontSize:"0.72rem", cursor:"pointer" }}>Siba yose</button>}
              </div>
            </div>

            {error && (
              <div style={{ background:"rgba(244,63,94,0.08)", border:"1px solid rgba(244,63,94,0.3)", borderRadius:6, padding:"10px 14px", marginBottom:16, fontSize:"0.85rem", color:"#be123c", display:"flex", alignItems:"center", gap:8 }}>
                <i className="bi bi-exclamation-triangle-fill" /> {error}
              </div>
            )}

            <button type="submit" disabled={sending || !question.trim()}
              style={{ width:"100%", padding:"12px", borderRadius:8, border:"none", background: (!question.trim() || sending) ? "#94a3b8" : "#0047AB", color:"#fff", fontWeight:700, cursor: (!question.trim() || sending) ? "not-allowed" : "pointer", fontSize:"0.95rem", display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}>
              {sending ? (
                <><span className="spinner-border spinner-border-sm" style={{ width:"1rem", height:"1rem" }} /> Kohereza...</>
              ) : (
                <><i className="bi bi-send-fill" /> Ohereza Ikibazo</>
              )}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
